import { render, staticRenderFns } from "./OVDetailBoletas.vue?vue&type=template&id=73149607&scoped=true&lang=pug"
import script from "./OVDetailBoletas.vue?vue&type=script&lang=js"
export * from "./OVDetailBoletas.vue?vue&type=script&lang=js"
import style0 from "./OVDetailBoletas.vue?vue&type=style&index=0&id=73149607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73149607",
  null
  
)

export default component.exports